<template>
  <div>
    <tag-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></tag-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import TagTable from './table';

export default {
  components: {
    DialogFormWrapper,
    TagTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
